import { createContext, useContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/theme.tsx
var context = createContext(null);
var { Provider } = context;
function ThemeProvider({ children, theme, inFieldset, columnAlign, columnHorizontalPad }) {
	const parentContext = useContext(context);
	const value = useMemo(() => ({
		theme: theme ?? parentContext?.theme ?? "light",
		inFieldset: inFieldset ?? parentContext?.inFieldset ?? false,
		columnAlign: columnAlign ?? parentContext?.columnAlign ?? "start",
		columnHorizontalPad: columnHorizontalPad ?? parentContext?.columnHorizontalPad ?? "md"
	}), [
		inFieldset,
		parentContext?.inFieldset,
		parentContext?.theme,
		theme,
		columnAlign,
		parentContext?.columnAlign,
		columnHorizontalPad,
		parentContext?.columnHorizontalPad
	]);
	return /* @__PURE__ */ jsx(Provider, {
		value,
		children
	});
}
function useTheme() {
	return useContext(context)?.theme ?? "light";
}
function useIsInFieldset() {
	return useContext(context)?.inFieldset ?? false;
}
function useColumnAlign() {
	return useContext(context)?.columnAlign ?? "start";
}
function useChildTheme(color, variant) {
	const theme = useTheme();
	return useMemo(() => {
		if (color !== "white" && ["solid", "outline"].includes(variant)) return color;
		if (color === "white" && variant !== "transparent") return "light";
		return theme;
	}, [
		theme,
		color,
		variant
	]);
}
function useColumnHorizontalPad() {
	return useContext(context)?.columnHorizontalPad ?? "md";
}
//#endregion
export { ThemeProvider, useChildTheme, useColumnAlign, useColumnHorizontalPad, useIsInFieldset, useTheme };
